import type { ExportResponse } from '@stuut/api-sdk/models';

export function canDownload(exp: ExportResponse): boolean {
  return exp.status === 'completed' && Boolean(exp.downloadUrl);
}

export function isCompleted(exp: ExportResponse): boolean {
  return exp.status === 'completed';
}

export function isFailed(exp: ExportResponse): boolean {
  return exp.status === 'failed';
}

export function isNotReady(exp: ExportResponse): boolean {
  return exp.status === 'pending' || exp.status === 'processing';
}

export function getInitials(name: string | null | undefined): string {
  if (!name) return '';
  return name
    .trim()
    .split(' ')
    .slice(0, 2)
    .map((n) => n.substring(0, 1).toUpperCase())
    .join('');
}
